import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { matchPath, useLocation } from 'react-router-dom';
import { axClient, axClientUpload } from '../../axiosClient';
import { base_URL } from '../../config';
import { useAppState } from '../../state';

interface meetingDetails {
  meeting_uid: string;
  join_url: string;
  total_participants: Number;
  is_recording: boolean;
  allow_guests: boolean;
  created_at: string;
  updated_at: string;
  meeting_status: string;
}

interface companyDetails {
  company_uid: string;
  company_logo: string;
  company_name: string;
  company_timezone: string;
}

interface jobDetails {
  job_uid: string;
  job_title: string;
}

interface contactDetails {
  home: number;
  mobile: number;
  work: number;
}

interface customerDetails {
  customer_uid: string;
  customer_first_name: string;
  customer_last_name: string;
  customer_email: string;
  customer_contact_no: contactDetails;
}

export interface IMeetingContext {
  meeting: meetingDetails;
  company: companyDetails;
  job: jobDetails;
  customer: customerDetails;
  roomName: string;
  userType: string;
  validLink: boolean;
  isMobile: boolean;
}

export default function useMeetingState() {
  const [company, setCompanyState] = useState<companyDetails>();
  const [job, setJobState] = useState<jobDetails>();
  const [customer, setCustomerState] = useState<customerDetails>();
  const [meeting, setmeetingState] = useState<meetingDetails>();
  const [validLink, setValidLink] = useState<boolean>();
  const { URLRoomName } = useParams();
  const location = useLocation();
  const { setError } = useAppState();
  const queryStr = window.location.search;
  const query = new URLSearchParams(queryStr);
  const roomName = URLRoomName;
  const isOnline = navigator.onLine === true;
  const toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];
  const isMobile = toMatch.some(toMatchItem => {
    return navigator.userAgent.match(toMatchItem);
  });
  //bearerToken if host and auth if guest

  const guest = matchPath(location.pathname, {
    path: '/guest/:id',
  })
    ? 'guest'
    : '';

  const host = matchPath(location.pathname, {
    path: '/room/:id',
  })
    ? 'host'
    : '';

  let userType = host ? 'host' : guest ? 'guest' : ' ';
  const region = query.get('region');
  axClient.defaults.baseURL = `https://${
    region ? region : 'staging'
  }.zuperpro.com/api/service/connect/meeting/${URLRoomName}`;
  axClientUpload.defaults.baseURL = `https://${region ? region : 'staging'}.zuperpro.com/api/`;

  if (host) {
    const bearerToken = query.get('token');
    axClient.defaults.headers.common['Authorization'] = `Bearer ${bearerToken}`;
    axClientUpload.defaults.headers.common['Authorization'] = `Bearer ${bearerToken}`;
  }

  if (guest || host) {
    const auth = query.get('auth');

    if (auth) {
      userType = 'guest';
      axClient.interceptors.request.use(config => {
        config.params = {};
        config.params['auth'] = auth;
        return config;
      });
    }
  }

  useEffect(() => {
    if (isOnline) {
      axClient
        .get(`/details`)
        .then(response => {
          setCompanyState(response.data.data.company);
          setJobState(response.data.data.job);
          setmeetingState(response.data.data.meeting);
          setCustomerState(response.data.data.customer);
          setValidLink(true);
        })
        .catch(err => {
          setValidLink(false);
          throw err;
        });
    } else setError({ code: 0, name: 'Network Error', message: 'Network Error' });
  }, []);

  return { meeting, company, job, customer, roomName, userType, validLink, isMobile };
}
